import axios, { AxiosResponse } from 'axios';
import Parts from '../models/data/Parts';
import PartsListRequest, {
  PartsDetailRequest,
} from '../models/requests/GetParts';
import { createRequestConfig } from './utils';

// 部品情報の取得関数
export default function requestPartsList(
  url: string,
  params?: PartsListRequest,
): Promise<AxiosResponse<Parts[]>> {
  const config = createRequestConfig({ params });
  return axios.get<Parts[]>(url, config);
}

// 部品情報件数の取得関数
export function requestCountParts(
  url: string,
  params?: PartsListRequest,
): Promise<AxiosResponse<number>> {
  const config = createRequestConfig({ params });
  return axios.get<number>(url, config);
}

// 部品の詳細情報の取得関数
export function requestPartsDetail(
  url: string,
  params?: PartsDetailRequest,
): Promise<AxiosResponse<Parts>> {
  const config = createRequestConfig({ params });
  return axios.get<Parts>(url, config);
}
